import { UserVideo, VideoExtensionRequestRecord } from '@/api/videoApi'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import SyncIcon from '@mui/icons-material/Sync'
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export function formatDuration(seconds: number): string {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return m > 0 ? `${m}:${s.toString().padStart(2, '0')} min` : `${s}s`
}

export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  return `${Math.floor(hrs / 24)}d ago`
}

export const STATUS_CONFIG = {
  pending: {
    label: 'Pending Review',
    icon: <HourglassEmptyIcon style={{ fontSize: '13px' }} />,
    color: 'bg-amber-500',
  },
  approved: {
    label: 'Approved',
    icon: <ThumbUpAltIcon style={{ fontSize: '13px' }} />,
    color: 'bg-blue-500',
  },
  processing: {
    label: 'Processing',
    icon: <SyncIcon style={{ fontSize: '13px' }} className="animate-spin" />,
    color: 'bg-purple-500',
  },
  completed: {
    label: 'Completed',
    icon: <CheckCircleIcon style={{ fontSize: '13px' }} />,
    color: 'bg-green-500',
  },
  rejected: {
    label: 'Rejected',
    icon: <CancelIcon style={{ fontSize: '13px' }} />,
    color: 'bg-red-500',
  },
  failed: {
    label: 'Failed',
    icon: <ErrorOutlineIcon style={{ fontSize: '13px' }} />,
    color: 'bg-red-600',
  },
} as const

export type ExtensionStatus = keyof typeof STATUS_CONFIG

export interface RequestWithVideo {
  request: VideoExtensionRequestRecord
  video: UserVideo | null
}
